export const getNestedProperty = <T>(obj: T, path: string): string => {
  const parts = path.split(".");
  let current: any = obj;
  for (const part of parts) {
    if (current === null || current === undefined) {
      return "- - -";
    }
    current = current[part];
  }
  return current === null || current === undefined ? "- - -" : String(current);
};
